import { observer } from "mobx-react-lite";

type TopNavLinkProps = {
  title: string;
  isSelected: boolean;
  onClick: () => void;
};

const TopNavLink = observer((props: TopNavLinkProps) => {
  const { isSelected, title, onClick } = props;
  const className = isSelected ? "selected" : "";

  return (
    <span className={className} onClick={onClick}>
      {title}
      <div className="bottom-border"></div>
    </span>
  );
});

export default TopNavLink;
